/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ResourceSearchItem} from '../models/ResourceSearchItem';

export interface SearchDatasetResources$Request {
    resourceName: string;
    accountId?: number;
    userId?: number;
}

export interface SearchDatasetResources$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchDatasetResourcesRequest = createAction<PayloadData<void, SearchDatasetResources$Request>>('DATASET_ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_DATASET_RESOURCES__REQUEST');
export const searchDatasetResourcesSuccess = createAction<PayloadData<Array<ResourceSearchItem>, SearchDatasetResources$Request>>('DATASET_ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_DATASET_RESOURCES__SUCCESS');
export const searchDatasetResourcesFailure = createAction<PayloadData<Error, SearchDatasetResources$Request, true>>('DATASET_ENTITLEMENTS_RESOURCE_SEARCH__SEARCH_DATASET_RESOURCES__FAILURE');

export const searchDatasetResourcesActions = [
    searchDatasetResourcesRequest,
    searchDatasetResourcesSuccess,
    searchDatasetResourcesFailure
] as const;

/**
 * @param {string} meta.resourceName
 * @param {number} [meta.accountId]
 * @param {number} [meta.userId]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchDatasetResources = (meta: SearchDatasetResources$Request, config?: SearchDatasetResources$Config) => {
    const TRANSPORT_GET_PARAMS = {
        resourceName: meta.resourceName,
        accountId: meta.accountId,
        userId: meta.userId,
    };
    return {
        CALL_API: {
            types: searchDatasetResourcesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dataset/entitlements/resources/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

